/**
 * @author Arul Vivek
 */

import service from '../Common/'
import constants from '../../../settings/shared/constants'


function createModelSpace(modelSpaceData) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.modelSpace.createModelSpace,
            method: 'POST',
            headers: headers,
            data:  modelSpaceData
        });
}

function getAllRunTimes() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.modelSpace.getRunTime,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
}

function deleteModelSpaceById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.modelSpace.deleteMS+'/'+id,
            method: 'DELETE',
            headers: headers,
            data:  ''
        }); 
}

function stopModelspacebyId(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.modelSpace.stopMS + id,
            method: 'DELETE',
            headers: headers,
            data:  ''
        }); 
}

function getRecentNotebooks() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.modelSpace.getRecents,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
}

function deleteRecentNotebookById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.modelSpace.deleteRecents + id,
            method: 'DELETE',
            headers: headers,
            data:  {}
        }); 
}

function getNotebookConnectionDetails(path) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.modelSpace.getConnectionDetails+"?filePath="+path,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
}

function getModelspaceDetails(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.modelSpace.getModelspaceDetails + id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
}

function createUpdateRecentNotebooks(recentData) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.modelSpace.createRecents,
            method: 'POST',
            headers: headers,
            data:  recentData
        });
}

function createStorageFileID(recentData) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.modelSpace.createStroageFileID,
            method: 'POST',
            headers: headers,
            data:  recentData
        });
}

function getStorageFileById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.modelSpace.getStroageFileByID+'/'+id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
}

function getConnectedModelspaceListById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.modelSpace.getConnectedList + id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
}

//To export run function
const ModelSpaceService = {
    createModelSpace,getAllRunTimes,deleteModelSpaceById,getRecentNotebooks,createUpdateRecentNotebooks,
    getNotebookConnectionDetails,createStorageFileID,getStorageFileById,getModelspaceDetails,getConnectedModelspaceListById,stopModelspacebyId,
    deleteRecentNotebookById
}
export default ModelSpaceService;